import { render } from "./template.vue?vue&type=template&id=e10d999c"
const script = {}

import "./template.vue?vue&type=style&index=0&id=e10d999c&lang=scss"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__